<div class="card mt-3 p-4" style="width: 450px; cursor: default;">
    <h6 class="text-center"  cvLocalizedText langSection="Left_Nav_Popup" langKey="New_System_Template">New System Template</h6>
    <div class="mt-3">
        <span cvLocalizedText langSection="Left_Nav_Popup" langKey="Name">Name</span><span class="ml-1 color-redRyder font-weight-bold">*</span>
        <input class="form-control mt-1" type="text" maxlength="50" [(ngModel)]="newSystemTemplate.name" cvLocalizedPlaceholder langSection="Left_Nav_Popup" langKey="Type_Name" />
    </div>
    <div class="mt-3">
        <span cvLocalizedText langSection="Left_Nav_Popup" langKey="Group">Group</span><span class="ml-1 color-redRyder font-weight-bold">*</span>
        <input class="form-control mt-1" type="text" maxlength="50" [(ngModel)]="newSystemTemplate.group" cvLocalizedPlaceholder langSection="Left_Nav_Popup" langKey="Type_Group" />
    </div>
    <div class="mt-3">
        <span cvLocalizedText langSection="Left_Nav_Popup" langKey="PersonaID">PersonaID</span><span class="ml-1 color-redRyder font-weight-bold">*</span>
        <mat-select class="form-control mt-1" [(ngModel)]="newSystemTemplate.personas" [multiple]="true">
            <div class="p-2">
                <div class="d-flex mb-2">
                    <button class="btn btn-sm btn-secondary" (click)="selectAllPersonas()">Select All</button>
                    <button class="btn btn-sm btn-secondary ml-1" (click)="selectNonePersonas()">Select None</button>
                </div>
                <div class="search-box live-search">
                    <input type="search" class="form-control" placeholder="Search" [(ngModel)]="personaFilter" onkeydown="event.stopPropagation()" />
                    <span class="clear-input" [hidden]="!personaFilter" (click)="personaFilter = ''"></span>
                </div>
            </div>
            <div class="overflow-auto" style="max-height: 180px">
                <mat-option *ngFor="let persona of personaList" [hidden]="!matchesPersonaFilter(persona)" [value]="persona.key">
                    {{ persona.name }}
                </mat-option>
            </div>
        </mat-select>
    </div>
    <div class="mt-3">
        <span cvLocalizedText langSection="Left_Nav_Popup" langKey="Integrations">Integrations</span><span class="ml-1 color-redRyder font-weight-bold">*</span>
        <mat-select class="form-control mt-1" [(ngModel)]="newSystemTemplate.integrations" [multiple]="true">
            <div class="p-2">
                <div class="d-flex mb-2">
                    <button class="btn btn-sm btn-secondary" (click)="selectAllIntegrations()">Select All</button>
                    <button class="btn btn-sm btn-secondary ml-1" (click)="selectNoneIntegrations()">Select None</button>
                </div>
                <div class="search-box live-search">
                    <input type="search" class="form-control" placeholder="Search" [(ngModel)]="integrationFilter" onkeydown="event.stopPropagation()" />
                    <span class="clear-input" [hidden]="!integrationFilter" (click)="integrationFilter = ''"></span>
                </div>
            </div>
            <div class="overflow-auto" style="max-height: 180px">
                <mat-option *ngFor="let integration of integrationList" [hidden]="!matchesFilter(integration)" [value]="integration.IntegrationID">
                    {{ integration.IntegrationName }}
                </mat-option>
            </div>
        </mat-select>
    </div>
    <div class="mt-3">
        <div cvLocalizedText langSection="Left_Nav_Popup" langKey="New_Description">Description</div>
        <textarea class="form-control form-control-lg mt-1" [(ngModel)]="newSystemTemplate.description" maxlength="1024" rows="7" style="resize: none; padding: 0.5rem;" type="text" cvLocalizedPlaceholder langSection="Left_Nav_Popup" langKey="Type_Description"></textarea>
    </div>
    <div class="d-flex justify-content-end mt-3">
        <button type="button" class="btn btn-text mr-2" (click)="cancel()" cvLocalizedText langSection="Left_Nav_Popup" langKey="Cancel">Cancel</button>
        <button type="button" class="btn btn-primary" [disabled]="shouldDisableSave()" (click)="save()" [attr.title]="saveTooltip">
            <span cvLocalizedText langSection="Left_Nav_Popup" langKey="Save">Save</span>
        </button>
    </div>
</div>
